import { render } from "./PurchaseProperty.vue?vue&type=template&id=722715c4&scoped=true"
import script from "./PurchaseProperty.vue?vue&type=script&lang=js"
export * from "./PurchaseProperty.vue?vue&type=script&lang=js"

import "./PurchaseProperty.vue?vue&type=style&index=0&id=722715c4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722715c4"]])

export default __exports__